import axios from "axios";
import { FETCH_INT_POST_WIHOUT_SEEN } from "./types";

export const fetchIntPostWithoutSeen = (post) => (dispatch) => {
  dispatch({
    type: FETCH_INT_POST_WIHOUT_SEEN,
    payload: post,
  });
};
